import React from "react";
import { Box, SxProps, Theme } from "@mui/material";

export default function StickyActionBar(props: {
  children: React.ReactNode;
  position?: "bottom" | "top";
  sx?: SxProps<Theme>;
}) {
  const { children, position = "bottom", sx } = props;

  return (
    <Box
      sx={{
        position: "sticky",
        ...(position === "top" ? { top: 0 } : { bottom: 0 }),
        zIndex: 1099, // below AppBar (usually 1100)

        // “invisible bar” but blocks content behind it
        backgroundColor: "#fff",
        boxShadow: "none",
        border: "none",

        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 1,

        pt: 2,
        pb: "calc(16px + env(safe-area-inset-bottom))",
        px: 0,

        ...(sx ?? {}),
      }}
    >
      {children}
    </Box>
  );
}
